module.exports = __webpack_public_path__ + "static/2front-sm-1-4a1e2c5ad9f209ad0687cf53bc39789d.png";